// src/modules/goldVault/api.js
import API from '../../services/api';

// ── Branch Vault ──────────────────────────────────────────────────────────────
export const getBranchVault = (branchId) =>
  API.get(`/vault/branch/${branchId}`).then((r) => r.data);

export const getBranchLedger = (branchId, params = {}) =>
  API.get(`/vault/branch/${branchId}/ledger`, { params }).then((r) => r.data);

export const addCaseToBranchVault = (branchId, data) =>
  API.post(`/vault/branch/${branchId}/add-case`, data).then((r) => r.data);

export const getBranchReconciliation = (branchId) =>
  API.get(`/vault/branch/${branchId}/reconciliation`).then((r) => r.data);

export const getBranchAging = (branchId) =>
  API.get(`/vault/branch/${branchId}/aging`).then((r) => r.data);

// ── HO Vault ──────────────────────────────────────────────────────────────────
export const getHOVault = () =>
  API.get('/vault/ho').then((r) => r.data);

export const getHOLedger = (params = {}) =>
  API.get('/vault/ho/ledger', { params }).then((r) => r.data);

export const getHOReconciliation = () =>
  API.get('/vault/ho/reconciliation').then((r) => r.data);

export const getHOAging = () =>
  API.get('/vault/ho/aging').then((r) => r.data);

export const getHOBranchSummary = () =>
  API.get('/vault/ho/branch-summary').then((r) => r.data);

// ── Purchase Ledger ───────────────────────────────────────────────────────────
export const getPurchaseLedger = (params = {}) =>
  API.get('/vault/purchase-ledger', { params }).then((r) => r.data);

export const getCaseTraceability = (caseType, caseId) =>
  API.get(`/vault/purchase-ledger/${caseType}/${caseId}`).then((r) => r.data);

// ── Inventory Transfers ───────────────────────────────────────────────────────
export const getTransfers = (params = {}) =>
  API.get('/vault/transfers', { params }).then((r) => r.data);

export const getTransferById = (id) =>
  API.get(`/vault/transfers/${id}`).then((r) => r.data);

export const createTransfer = (data) =>
  API.post('/vault/transfers', data).then((r) => r.data);

export const approveTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/approve`, data).then((r) => r.data);

export const withdrawTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/withdraw`, data).then((r) => r.data);

export const packTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/pack`, data).then((r) => r.data);

export const dispatchTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/dispatch`, data).then((r) => r.data);

export const receiveTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/receive`, data).then((r) => r.data);

export const verifyTransfer = (id, data) =>
  API.patch(`/vault/transfers/${id}/verify`, data).then((r) => r.data);

export const closeTransfer = (id) =>
  API.patch(`/vault/transfers/${id}/close`).then((r) => r.data);

export const getTransferSLA = () =>
  API.get('/vault/transfers/sla').then((r) => r.data);

// ── Transfer Approval Workflow (INVENTORY_TRANSFER_APPROVAL) ───────────────────
// Full workflow state for a transfer: which flow was triggered, every step, who
// can approve, current + next approver, facts, and decision history.
export const getTransferApproval = (id) =>
  API.get(`/vault/transfers/${id}/approval`).then((r) => r.data);

// Approve/reject the transfer's current approval step. action = 'approved' | 'rejected'.
export const decideTransferApproval = (id, { action, comment }) =>
  API.patch(`/vault/transfers/${id}/approval/decision`, { action, comment }).then((r) => r.data);

// Send back a transfer to the previous lifecycle step.
export const sendBackTransferStep = (id, { comment }) =>
  API.patch(`/vault/transfers/${id}/approval/send-back`, { comment }).then((r) => r.data);

// ── Inventory Explorer ────────────────────────────────────────────────────────
export const explorerSearch = (q) =>
  API.get('/vault/explorer/search', { params: { q } }).then((r) => r.data);

export const getCaseTimeline = (caseType, caseId) =>
  API.get(`/vault/explorer/case/${caseType}/${caseId}/timeline`).then((r) => r.data);

// ── Transfer Document PDF ─────────────────────────────────────────────────────
// Fetched through the axios client so the request carries the auth token and
// hits the configured backend host (a plain <a href> does neither).
export const downloadTransferDocument = (id) =>
  API.get(`/vault/transfers/${id}/document`, { responseType: 'blob' }).then((r) => r.data);

// ── Package Proof-of-Delivery Photos ─────────────────────────────────────────
export const addPackagePhotos = (packageId, photos) =>
  API.patch(`/vault/packages/${packageId}/photos`, { photos }).then((r) => r.data);

export const removePackagePhoto = (packageId, fileId) =>
  API.delete(`/vault/packages/${packageId}/photos/${fileId}`).then((r) => r.data);

// ── Vault Audit Log ───────────────────────────────────────────────────────────
export const getAuditLog = (params = {}) =>
  API.get('/vault/audit-log', { params }).then((r) => r.data);

export const overrideVaultBalance = (data) =>
  API.post('/vault/audit-log/override-vault', data).then((r) => r.data);

export const overrideCaseInventoryStatus = (data) =>
  API.post('/vault/audit-log/override-case-status', data).then((r) => r.data);

export const signOffReconciliation = (data) =>
  API.post('/vault/audit-log/sign-off-reconciliation', data).then((r) => r.data);
